"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreviewTenantConfig = void 0;
const useIsStandaloneMode_1 = require("./useIsStandaloneMode");
/**
 * Use previewTenantConfig to manually populate a FeatureAppModel
 * and simulate the usage of a tenant app. (See onesight readme)
 *
 * A previewTenantConfig only is returned in standalone mode.
 */
function usePreviewTenantConfig(customConfig) {
    const isStandalone = (0, useIsStandaloneMode_1.useIsStandaloneMode)();
    if (isStandalone) {
        return {
            marketId: (customConfig === null || customConfig === void 0 ? void 0 : customConfig.marketId) || "DEV",
            appName: (customConfig === null || customConfig === void 0 ? void 0 : customConfig.appName) || __FEATURE_APP_NAME__,
            stage: (customConfig === null || customConfig === void 0 ? void 0 : customConfig.stage) || "dev",
        };
    }
    return undefined;
}
exports.usePreviewTenantConfig = usePreviewTenantConfig;
//# sourceMappingURL=usePreviewTenantConfig.js.map